export default __webpack_public_path__ + "static/media/roadmapV2Bg.99101eba.png";